<form [formGroup]="dynamicForm">
  @for (control of formStructure; track control) {
    @switch (control.type) {
      @case ('text') {
        <c-input
          [label]="control.label"
          [showError]="showErrors"
          [maxLength]="control.maxLength"
          [formControlName]="control.name"
          [attr.data-test-id]="'dynamic-form-component.' + control.label + '.c-input'"
        />
      }
      @case ('singleSelect') {
        <c-radio
          [label]="control.label"
          [options]="control.options"
          [showError]="showErrors"
          [fullWidth]="true"
          [formControlName]="control.name"
          [attr.data-test-id]="'dynamic-form-component.' + control.label + '.c-radio'"
        />
      }
      @case ('number') {
        <c-input
          type="number"
          inputMode="numeric"
          [label]="control.label"
          [showError]="showErrors"
          [formControlName]="control.name"
          [attr.data-test-id]="'dynamic-form-component.' + control.label + '.c-input'"
        />
      }
      @case ('date') {
        <c-date-picker
          [label]="control.label"
          [showError]="showErrors"
          [formControlName]="control.name"
          [attr.data-test-id]="'dynamic-form-component.' + control.label + '.c-date-picker'"
        />
      }
    }
  }
</form>
